export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGOUT = 'LOGOUT';
export const GET_TOKEN = 'GET_TOKEN';

export const LOADING = 'LOADING';
export const LOADING_SUCCESS = 'LOADING_SUCCESS';

export const GET_APPOINTMENTS = 'GET_APPOINTMENTS';
export const SET_CURRENT_APPOINTMENTS = 'SET_CURRENT_APPOINTMENTS';
export const SET_CURRENT_DATES = 'SET_CURRENT_DATES';
export const SET_CURRENT_CALENDAR_DAY = 'SET_CURRENT_CALENDAR_DAY';
export const GET_APPOINTMENTS_SUCCESS = 'GET_APPOINTMENTS_SUCCESS';
export const GET_APPOINTMENT_TYPES_SUCCESS = 'GET_APPOINTMENT_TYPES_SUCCESS';
export const ADD_APPOINTMENT = 'ADD_APPOINTMENT';
export const ADD_APPOINTMENT_SUCCESS = 'ADD_APPOINTMENT_SUCCESS';
export const SELECT_APPOINTMENT = 'SELECT_APPOINTMENT';
export const UNSELECT_APPOINTMENT = 'SELECT_APPOINTMENT';
export const APPOINTMENT_SELECTED = 'APPOINTMENT_SELECTED';
export const APPOINTMENT_DELETED = 'APPOINTMENT_DELETED';

export const SET_FETCHED_APPOINTMENT_DATES = 'SET_FETCHED_APPOINTMENT_DATES';


export const GET_BUSINESS_INFO = 'GET_BUSINESS_INFO';
export const GET_CLIENTS = 'GET_CLIENTS';
export const CLIENT_FETCHED = 'CLIENT_FETCHED';

export const SET_CURRENT_SEARCHED_CLIENTS = 'SET_CURRENT_SEARCHED_CLIENTS';

// BOOKING APPS

export const SET_CLIENT = 'SET_CLIENT';
export const SET_CURRENT_DAY = 'SET_CURRENT_DAY';
export const SET_CURRENT_APPOINTMENT = 'SET_CURRENT_APPOINTMENT';
export const SET_AVAILABLE_APPOINTMENTS = 'SET_AVAILABLE_APPOINTMENTS';
export const SELECT_SLOT = 'SELECT_SLOT';
export const SET_EDIT_MODE = 'SET_EDIT_MODE';
export const CLEAR_BOOKING = 'CLEAR_BOOKING';
export const SET_APPOINTMENT_TYPE = 'SET_APPOINTMENT_TYPE';
export const SET_APPOINTMENT_DETAILS = 'SET_APPOINTMENT_DETAILS';

export const APPOINTMENT_UPDATED = 'APPOINTMENT_UPDATED';
export const APPOINTMENT_ADDED = 'APPOINTMENT_ADDED';
export const SET_OVERLAPPING_SLOTS = 'SET_OVERLAPPING_SLOTS';

// CLEAR DATA

export const CLEAR_APPOINTMENTS = 'CLEAR_APPOINTMENTS';
export const CLEAR_APPOINTMENT_TYPES = 'CLEAR_APPOINTMENT_TYPES';
export const CLEAR_BUSINESS_INFO = 'CLEAR_BUSINESS_INFO';


// NOTIFICATIONS

export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';
export const CANCEL_POLL_NOTIFICATIONS = 'CANCEL_POLL_NOTIFICATIONS';
export const START_POLL_NOTIFICATIONS = 'START_POLL_NOTIFICATIONS';
export const SET_NOTIFICATION_ID = 'SET_NOTIFICATION_ID';

// UI
export const SHOW_NOTIFICATIONS = 'SHOW_NOTIFICATIONS';
export const CLOSE_NOTIFICATIONS = 'CLOSE_NOTIFICATIONS';
export const TOGGLE_NOTIFICATIONS = 'TOGGLE_NOTIFICATIONS';

export const SHOW_BOOKING_MODAL = 'SHOW_BOOKING_MODAL';
export const CLOSE_BOOKING_MODAL = 'CLOSE_BOOKING_MODAL';
export const TOGGLE_BOOKING_MODAL = 'TOGGLE_BOOKING_MODAL';

export const SHOW_SETTINGS = 'SHOW_SETTINGS';
export const CLOSE_SETTINGS = 'CLOSE_SETTINGS';
export const TOGGLE_SETTINGS = 'TOGGLE_SETTINGS';

export const SHOW_MINI_CALENDAR = 'SHOW_MINI_CALENDAR';
export const CLOSE_MINI_CALENDAR = 'CLOSE_MINI_CALENDAR';
export const TOGGLE_MINI_CALENDAR = 'TOGGLE_MINI_CALENDAR';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js